import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {ArenaInfoPreviewComponent} from './parts/arena-info-preview/arena-info-preview.component';
import {GameInfoPreviewComponent} from './parts/game-info-preview/game-info-preview.component';
import {observer} from 'mobx-react';
import {IStickyHandler} from '../../sticky-handler/sticky-handler.interface';
import {Check} from '@sparkware/app-utils';


export interface LobbyGamesInfoComponentProps {
  stickyHandler?: IStickyHandler;
  arenaInfo: {
    previewImage: string;
    title: string;
    description: string;
  }
}

@observer
export class PcGameInfoPreviewComponent extends OrbitComponent<LobbyGamesInfoComponentProps> {

    componentDidMount() {
        super.componentDidMount();
        if(!this.services.device.isMobile) {
            this.services.lobbyGameInfoPreview.enableGamePreview();
        }

    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if(!this.services.device.isMobile) {
            this.services.lobbyGameInfoPreview.disableGamePreview();
        }
    }


    render() {
        if (this.services.device.isMobile) {
            return null;
        }

        let enabledOnPC = this.services.configuration.data.generalSettings?.gamesPreviewConfig?.enabledOnPC;
        if(Check.isNullOrUndefined(enabledOnPC)) {
            enabledOnPC = true;
        }

        if(!enabledOnPC) {
            return null;
        }

        if (this.services.lobbyGameInfoPreview.currentPreviewedGame) {
            return (<GameInfoPreviewComponent isSticky={this.props.stickyHandler?.isSticky} gameInfo={this.services.lobbyGameInfoPreview.currentPreviewedGame}/>);
        } else {
            return (<ArenaInfoPreviewComponent isSticky={this.props.stickyHandler?.isSticky} arenaInfo={this.props.arenaInfo}/>);
        }
    }

}
